import { ProductCardDtoResponse } from './product-card-dto-response';

export class GenericSummaryCardDtoResponse {
	title: string;
  description: string;
  productType: string;
  productTypeWarning: string;
  productBrand: string;
  frontProduct: ProductCardDtoResponse;
  rearProduct: ProductCardDtoResponse;
  recommended: boolean;
  keys: string[];
  visible: boolean = true;
  selected: boolean;
  //jl: web api does not have corresponding column so defaultWarehouse is always null
  //defaultWarehouse: string;
  productStatus: string;
  type: string;
  pairNo: string;
  valve: string;
  valveNumber: string;
	optionalValve: string;
  wmbRequired: boolean;
}
